import { useSetPageTitle } from "@/context/PageTitleContext";
import { Route, Routes } from "react-router-dom";
import TeachersSupervision from "./teachers-supervision";

const TeachersSupervisionRoutes = () => {
  useSetPageTitle("Controllo attività docenti", "Monitora pubblicazioni e materiale dei docenti");
  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-5xl space-y-4">
        <Routes>
          <Route index element={<TeachersSupervision />} />
        </Routes>
      </div>
    </div>
  );
};

export default TeachersSupervisionRoutes;
